import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "currentColor",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "18",
    height: "18",
    x: "3",
    y: "3",
    rx: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFF",
    "fill-rule": "nonzero",
    d: "M16.749 8.207a.714.714 0 0 0-1.01.005l-5.208 5.265-2.305-2.369a.714.714 0 1 0-1.024.996l2.813 2.89q.002.003.006.005l.003.005c.045.045.101.072.154.102.028.015.05.04.078.051a.7.7 0 0 0 .538.002c.027-.012.049-.035.075-.049.054-.03.11-.056.155-.101q.002-.004.005-.006l.005-.004 5.72-5.782a.715.715 0 0 0-.005-1.01"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }